import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  tokens: {
    accessToken: string | null;
    refreshToken: string | null;
  };
  user: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    role?: string;
  } | null;
  isRefreshing: boolean;
  error: string | null;
}

const initialState: AuthState = {
  tokens: {
    accessToken: null,
    refreshToken: null,
  },
  user: null,
  isRefreshing: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateTokens: (
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) => {
      state.tokens.accessToken = action.payload.accessToken;
      state.tokens.refreshToken = action.payload.refreshToken;
      state.error = null;
    },
    setUser: (
      state,
      action: PayloadAction<{
        id: string;
        email: string;
        firstName?: string;
        lastName?: string;
        role?: string;
      }>
    ) => {
      state.user = action.payload;
    },
    startRefreshing: (state) => {
      state.isRefreshing = true;
      state.error = null;
    },
    refreshFailed: (state, action: PayloadAction<string>) => {
      state.isRefreshing = false;
      state.error = action.payload;
    },
    refreshSuccess: (state) => {
      state.isRefreshing = false;
      state.error = null;
    },
    logout: (state) => {
      state.tokens.accessToken = null;
      state.tokens.refreshToken = null;
      state.user = null;
      state.isRefreshing = false;
      state.error = null;
    },
  },
});

export const {
  updateTokens,
  setUser,
  startRefreshing,
  refreshFailed,
  refreshSuccess,
  logout,
} = authSlice.actions;

export default authSlice.reducer;
